const formatLettersOnly = (value: string) => {
  return value.replace(/[^A-Za-z\s]/g, '');
};

const formatMMYYYY = (value: string) => {
  const digitsOnly = value.replace(/\D/g, '');

  if (!digitsOnly) return '';

  if (digitsOnly.length === 1) {
    if (digitsOnly[0] !== '0' && digitsOnly[0] !== '1') return '';

    return digitsOnly;
  }

  const mm = digitsOnly.slice(0, 2);
  const month = parseInt(mm, 10);

  if (month < 1 || month > 12) return digitsOnly[0];
  if (digitsOnly.length <= 2) return mm;

  const result = mm + '/';

  const yearPart = digitsOnly.slice(2, 6);

  if (yearPart.length >= 1) {
    if (yearPart[0] !== '1' && yearPart[0] !== '2') return result;
  }

  return result + yearPart;
};

const formatStateAbbreviation = (value: string) => {
  return value
    .replace(/[^A-Za-z]/g, '')
    .toUpperCase()
    .slice(0, 2);
};

const formatGPA = (value: string) => {
  const digitsAndDot = value.replace(/[^0-9.]/g, '');

  return digitsAndDot.slice(0, 4);
};

export { formatLettersOnly, formatMMYYYY, formatStateAbbreviation, formatGPA };
